import React from 'react';
import { useGamification } from '../hooks/GamificationContext';

export function ProfileGamification() {
    const { xp = 0, level = 0, rank = null, progress = null, loading = false, hasLoaded = false, loadError = null } = useGamification();

    if (loading && !hasLoaded) {
        return (
            <div style={{ border: '2px solid #0073aa', padding: '1rem', borderRadius: '8px', margin: '1rem 0', background:'#f8faff', color: '#5b6875' }}>
                Lade deinen serverseitigen Profilstand …
            </div>
        );
    }

    if (loadError && !hasLoaded) {
        return (
            <div style={{ border: '2px solid #d9534f', padding: '1rem', borderRadius: '8px', margin: '1rem 0', background:'#fff5f5', color: '#8a2b2b' }}>
                Dein Profilstand konnte gerade nicht vom Server geladen werden.
            </div>
        );
    }

    const fallbackNextLevelXP = Math.pow(level + 1, 2) * 100;
    const resolvedProgress = progress || {
        next_level_xp: fallbackNextLevelXP,
        progress_in_level: xp,
        progress_needed: fallbackNextLevelXP,
        progress_percent: Math.min(100, Math.round((xp / Math.max(1, fallbackNextLevelXP)) * 100)),
        xp_to_next_level: Math.max(0, fallbackNextLevelXP - xp),
    };

    const resolvedRank = rank || {
        title: level >= 12 ? 'Admiral' : level >= 8 ? 'Kapitän' : level >= 5 ? 'Steuermann' : level >= 3 ? 'Deckhelfer' : 'Matrose',
        icon: level >= 12 ? '👑' : level >= 8 ? '🏴‍☠️' : level >= 5 ? '⚓' : level >= 3 ? '🪝' : '🧭',
    };

    return (
        <div style={{ border: '2px solid #0073aa', padding: '1rem', borderRadius: '8px', margin: '1rem 0', background:'#f8faff' }}>
            <h3 style={{ marginBottom: '0.5rem', color: '#0073aa' }}>
                {resolvedRank.icon} {resolvedRank.title} (Level {level})
            </h3>

            <p style={{ margin: '0.25rem 0' }}>
                XP: {xp} / {resolvedProgress.next_level_xp}
            </p>

            <p style={{ margin: '0.25rem 0', color: '#5b6875', fontSize: '0.95rem' }}>
                {resolvedProgress.progress_in_level} / {resolvedProgress.progress_needed} XP in diesem Level · noch {resolvedProgress.xp_to_next_level} XP bis zum nächsten Level
            </p>

            <div style={{ background:'#ddd', borderRadius:'6px', overflow:'hidden', height:'20px', marginTop:'0.5rem' }}>
                <div
                    style={{
                        width: `${resolvedProgress.progress_percent}%`,
                        background:'#0073aa',
                        height:'100%',
                        transition:'width 0.3s ease'
                    }}
                />
            </div>
        </div>
    );
}
